<template>
  <v-card class="fillheight table_auth pb-2 d-flex" flat>
    <div class="flex-grow-1 full-width full-height overflow-hidden">
      <component
        :is="componentsLoad"
        v-bind="$attrs"
        :headers="c_headers"
        :isScrollLoad="c_isScrollLoad"
        :loading="loading"
        :pagination="pagination"
        :useSelected="useSelected"
        v-on="$listeners"
      >
        <template #no-data>
          <slot name="no-data" />
        </template>
        <template v-for="slot in slotItemHeader" v-slot:[slot]="props">
          <slot v-bind="props" :name="slot" />
        </template>
        <template v-for="slot in slotItemRow" v-slot:[slot]="props">
          <slot v-bind="props" :name="slot" />
        </template>
      </component>
    </div>
    <div v-if="!c_isScrollLoad" class="flex-grow-0 pt-2">
      <base-pagination
        :disabled="loading"
        :page.sync="p_pagination.page"
        :perpage.sync="p_pagination.itemsPerPage"
        :total="p_pagination.total"
        @update="updatePagination()"
      ></base-pagination>
    </div>
  </v-card>
</template>

<script>
import asyncComponent from '../../async'
export default {
  components: {
    BaseGrid: () =>
      asyncComponent(
        import(
          /* webpackChunkName: "base-table-async" */ '../grid/base-grid.vue'
        ),
        { type: 'table-thead, table-tbody' }
      ),
    BaseInfiniteScroll: () =>
      asyncComponent(
        import(
          /* webpackChunkName: "base-table-async" */ '../infinite-scroll/base-infinite-scroll.vue'
        ),
        { type: 'table-thead, table-tbody' }
      ),
  },
  name: 'base-table',
  inheritAttrs: false,
  props: {
    isScrollLoad: { type: Boolean, default: true },
    loading: Boolean,
    pagination: { type: Object, default: () => ({}) },
    optionTarget: { type: String, default: 'top-table' },
    useSelected: Boolean,
    /** @type {Array<{text: string, value: string, hidden: boolean}>} */
    headers: { default: () => [], type: Array, required: true },
    mode: {
      type: String,
      default: 'list',
      validator: function(value) {
        return ['list', 'grid', 'table'].indexOf(value) !== -1
      },
    },
  },
  data: () => ({
    currentHeader: [],
    p_mode: 'list',
    p_pagination: {
      page: 1,
      itemsPerPage: 10,
    },
  }),
  watch: {
    pagination: {
      handler(value) {
        this.p_pagination = value
      },
      immediate: true,
    },
    mode: {
      handler(value) {
        this.p_mode = value
      },
      immediate: true,
    },
    headers: {
      handler(value) {
        if (value) {
          this.currentHeader = value.map((x) => ({ hidden: false, ...x }))
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    c_isScrollLoad() {
      return this.isScrollLoad
    },
    c_headers() {
      return this.currentHeader.filter((header) => !header.hidden)
    },
    componentsLoad() {
      if (this.isGrid) return 'base-grid'
      return 'base-infinite-scroll'
    },
    isTable() {
      return this.c_mode == 'table'
    },
    isGrid() {
      return this.c_mode == 'grid'
    },
    isList() {
      return this.c_mode == 'list'
    },
    c_mode: {
      get() {
        return this.p_mode
      },
      set(value) {
        this.p_mode = value
        this.$emit('update:mode', value)
      },
    },
    slotItemRow() {
      return Object.keys(this.$scopedSlots).filter((x) => x.includes('item'))
    },
    slotItemHeader() {
      return Object.keys(this.$scopedSlots).filter((x) => x.includes('header'))
    },
  },
  methods: {
    updatePagination() {
      this.$emit('update:pagination', this.p_pagination)
      this.$emit('loadMore')
    },
  },
}
</script>

<style lang="scss">
.table-select {
  width: 60px;
}

// .table_auth thead th {
//   position: sticky;
//   top: 0;
//   z-index: 1;a
// }
.table_auth table {
  border-collapse: collapse;
  width: 100%;
}
</style>

<style scoped lang="scss">
.wordspaces-table,
.wordspaces-grid {
  width: 100%;
  padding: 0 10px 10px;
}
</style>
